import { FormGroup, ValidatorFn } from '@angular/forms';
import { ActivatedRouteSnapshot } from '@angular/router';
import { differenceInCalendarWeeks, getWeek } from 'date-fns';
import { IWorkingDay } from '../../modules/authorization/store/types';
import { ITimeRecord } from '../../modules/logged/time-records/store/types';
import { da, el } from 'date-fns/locale';

export const uniqueID = (): string => {
    return '_' + Math.random().toString(36).substr(2, 9);
};

export const getDataFromRoute = (route: ActivatedRouteSnapshot): any => {
    let lastChild: ActivatedRouteSnapshot = route;
    let child: ActivatedRouteSnapshot = route;
    while (child) {
        if (child.firstChild) {
            child = child.firstChild;
            lastChild = child;
        } else {
            child = null;
        }
    }
    return lastChild.data;
};

export const transformToFormData = (data: any, fileNames?: string[]): FormData => {
    const formData = new FormData();
    Object.keys(data).map((key: string) => {
        if (fileNames && fileNames.indexOf(key) !== -1) {
            if (typeof data[key] !== 'string') {
                formData.append(key, data[key] || '');
            }
        } else {
            if (typeof data[key] === 'boolean') {
                formData.append(key, data[key] ? '1' : '0');
            } else {
                formData.append(key, data[key] || '');
            }
        }
    });
    return formData;
};

export const getNumber = (value: any): number => {
    return parseFloat(value) || 0;
};

export const resolvePath = (object: any, path: string, defaultValue: any = null) => path.split('.').reduce((o, p) => (o ? o[p] : defaultValue), object);

// TODO refactor all of these downloads

export const downloadXLSX = (data: any) => {
    const contentDisposition = data.headers.get('Content-Disposition');
    const filename = decodeURIComponent(contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, ''));

    const a = document.createElement('a');
    const blob = new Blob([data.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
};

export const downloadZIP = (data: any) => {
    const contentDisposition = data.headers.get('Content-Disposition');
    const filename = decodeURIComponent(contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, ''));

    const a = document.createElement('a');
    const blob = new Blob([data.body], { type: 'application/zip' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
};

export const downloadCSV = (data: any) => {
    const contentDisposition = data.headers.get('Content-Disposition');
    const filename = decodeURIComponent(contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, ''));

    const a = document.createElement('a');
    const blob = new Blob([data.body], { type: 'application/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
};

export const downloadTXT = (data: any) => {
    const contentDisposition = data.headers.get('Content-Disposition');
    const filename = decodeURIComponent(contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, ''));

    const a = document.createElement('a');
    const blob = new Blob([data.body], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
};

export const downloadPDF = (data: any) => {
    const contentDisposition = data.headers.get('Content-Disposition');
    let filename;

    if (contentDisposition) {
        filename = decodeURIComponent(contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, ''));
    } else {
        filename = new Date().getMilliseconds().toString() + '-' + Math.floor(Math.random() * 10000000).toString();
    }

    const a = document.createElement('a');
    const blob = new Blob([data.body], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
};

export const downloadJPG = (data: any) => {
    const contentDisposition = data.headers.get('Content-Disposition');
    let filename;

    if (contentDisposition) {
        filename = decodeURIComponent(contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, ''));
    } else {
        filename = new Date().getMilliseconds().toString() + '-' + Math.floor(Math.random() * 10000000).toString();
    }

    const a = document.createElement('a');
    const blob = new Blob([data.body], { type: 'image/jpeg' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
};

export const downloadFile = (data: any, extension: string): boolean => {
    extension = extension.toLowerCase();
    if (!fileTypes[extension]) {
        return false;
    }
    const contentDisposition = data.headers.get('Content-Disposition');
    let filename;

    if (contentDisposition) {
        filename = decodeURIComponent(contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, ''));
    } else {
        filename = new Date().getMilliseconds().toString() + '-' + Math.floor(Math.random() * 10000000).toString();
    }

    const a = document.createElement('a');
    const blob = new Blob([data.body], { type: fileTypes[extension] });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
    return true;
};

export const downloadPNG = (data: any) => {
    const contentDisposition = data.headers.get('Content-Disposition');
    let filename;

    if (contentDisposition) {
        filename = decodeURIComponent(contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, ''));
    } else {
        filename = new Date().getMilliseconds().toString() + '-' + Math.floor(Math.random() * 10000000).toString();
    }

    const a = document.createElement('a');
    const blob = new Blob([data.body], { type: 'image/png' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
};

export const checkSovereignEmail = (email: string) => {
    const regex = /^(office_)[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(sovereignplus)\.com$/g;
    return regex.test(email);
};

export const fileType = (url: string): string => {
    return url.split('.').pop().toLowerCase();
};

export const getRateType = (rateType: string): string => {
    if (rateType === 'Daily') {
        return 'd';
    } else if (rateType === 'Weekly') {
        return 'w';
    }
    return 'h';
};

export const getSubcontractorPayrollLabel = (status: string): { label: string; color: string } => {
    switch (status) {
        case 'CREATED':
            return { label: 'Created', color: 'transparent' };
        case 'INVOICES_ISSUED':
            return { label: 'Pending', color: 'orange' };
        case 'NOTIFICATION_SENT':
        case 'INVOICES_PAID':
        case 'SCHEDULED_FOR_PAYMENT':
            return { label: 'Pending payment', color: 'orange' };
        case 'COMPLETED':
            return { label: 'Paid', color: 'green' };
        default:
            return null;
    }
};

export const getWeekFromSixthApril = (): number => {
    const fiscalYearStart = new Date(new Date().getFullYear(), 3, 6); // April 6th of the current year
    const today = new Date();

    // Adjust fiscal year start if we're still in the previous fiscal year
    if (today < fiscalYearStart) {
        fiscalYearStart.setFullYear(fiscalYearStart.getFullYear() - 1);
    }

    // const oneWeek = 1000 * 60 * 60 * 24 * 7; // milliseconds in one week
    // const diffInTime = today.getTime() - fiscalYearStart.getTime();
    // const diffInWeeks = Math.ceil(diffInTime / oneWeek);

    return Math.abs(differenceInCalendarWeeks(fiscalYearStart, today));
};

export const updateValidators = (form: FormGroup, formPath: string, newValidator: ValidatorFn | ValidatorFn[]): void => {
    form.get(formPath).setValidators(newValidator);
    form.get(formPath).updateValueAndValidity();
};

export enum fileTypes {
    jpg = 'image/jpeg',
    jepg = 'image/jpeg',
    txt = 'text/plain',
    png = 'image/png',
    pdf = 'application/pdf',
}

export const transformHoursToOffset = (time: string): number => {
    if (!time) {
        return 0;
    }
    const [hoursAndMinutes, half] = time?.split(' ');
    const [hours, minutes] = hoursAndMinutes?.split(':');

    return ((parseInt(hours, undefined) || 0) + (half === 'PM' ? 12 : 0)) * 60 + (parseInt(minutes, undefined) || 0);
};

export const transformOffsetToHours = (offset: number): string => {
    const hours = Math.floor(offset / 60);
    let minutes = offset % 60;
    // @ts-ignore
    minutes = minutes >= 10 ? minutes : '0' + minutes;
    const half = hours >= 12 ? 'PM' : 'AM';

    return (hours % 12) + ':' + minutes + ' ' + half;
};

export const getCompanyWorkingDay = (date: string, workingDays: IWorkingDay[]): IWorkingDay | null => {
    const workingDay = (workingDays || []).find((element) => element.day_of_week === new Date(date).getDay());
    return !workingDay || !workingDay.enabled ? null : workingDay;
};

export const isTrackingValidWithWorkingHours = (timeTracking: ITimeRecord, workingDay: IWorkingDay): boolean => {
    let valid = false;
    const start = new Date(timeTracking.start_date);
    const startOffset = start.getHours() * 60 + start.getMinutes();
    const end = new Date(timeTracking.end_date);
    const endOffset = end.getHours() * 60 + end.getMinutes();

    if (workingDay && startOffset >= workingDay.from && startOffset < workingDay.to && endOffset >= workingDay.from && endOffset < workingDay.to) {
        valid = true;
    }

    return valid;
};

export const prepareWeekRange = (date): { from: Date; to: Date } => {
    const from = new Date(date.getTime());
    from.setDate(from.getDate() - (from.getDay() !== 0 ? from.getDay() - 1 : 6));
    from.setHours(0, 0, 0, 0);

    const to = new Date(date.getTime());
    to.setDate(to.getDate() + (to.getDay() !== 0 ? 7 - to.getDay() : 0));
    to.setHours(23, 59, 59, 999);

    return {
        from,
        to,
    };
};

export const constructDateFromMonthAndYear = (year: string, month: string, start = true): Date => {
    const date = new Date();
    date.setUTCFullYear(parseInt(year, null), parseInt(month, null), 1);
    date.setUTCHours(0, 0, 0, 0);
    if (start) {
        return date;
    } else {
        date.setUTCMonth(date.getUTCMonth() + 1);
        date.setUTCMilliseconds(date.getUTCMilliseconds() - 1);
        return date;
    }
};
